export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-info-c7ee43fe5ce88bfcd8dc29836e3243ad.svg";